export function downloadFile(response, libelle, extension, target) {

  let mimeType = 'application/octet-stream'

  if (extension.toLowerCase() === 'jpeg' || extension.toLowerCase() === 'jpg') {
    mimeType = 'image/jpeg'
  } else if (extension.toLowerCase() === 'gif' || extension.toLowerCase() === 'png') {
    mimeType = 'image/' + extension.toLowerCase()
  } else if (extension.toLowerCase() === 'tiff' || extension.toLowerCase() === 'tif') {
    mimeType = 'image/tiff'
  } else if (extension.toLowerCase() === 'csv') {
    mimeType = 'text/csv'
  } else if (extension.toLowerCase() === 'doc') {
    mimeType = 'application/msword'
  } else if (extension.toLowerCase() === 'docx') {
    mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  } else if (extension.toLowerCase() === 'odp') {
    mimeType = 'application/vnd.oasis.opendocument.presentation'
  } else if (extension.toLowerCase() === 'ods') {
    mimeType = 'application/vnd.oasis.opendocument.spreadsheet'
  } else if (extension.toLowerCase() === 'odt') {
    mimeType = 'application/vnd.oasis.opendocument.text'
  } else if (extension.toLowerCase() === 'pdf') {
    mimeType = 'application/pdf'
  } else if (extension.toLowerCase() === 'ppt') {
    mimeType = 'application/vnd.ms-powerpoint'
  } else if (extension.toLowerCase() === 'pptx') {
    mimeType = 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
  } else if (extension.toLowerCase() === 'rar') {
    mimeType = 'application/x-rar-compressed'
  } else if (extension.toLowerCase() === 'zip') {
    mimeType = 'application/zip'
  } else if (extension.toLowerCase() === '7z') {
    mimeType = 'application/x-7z-compressed'
  } else if (extension.toLowerCase() === 'xls') {
    mimeType = 'application/vnd.ms-excel'
  } else if (extension.toLowerCase() === 'xml') {
    mimeType = 'text/xml'
  } else if (extension.toLowerCase() === 'xlsx') {
    mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  } else {
    mimeType = 'application/octet-stream'
  }

  let newBlob = new Blob([response.data], {type: mimeType})

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob)
    return
  }

  const data = window.URL.createObjectURL(newBlob)
  if (window.webkitURL) {
    const data = window.webkitURL.createObjectURL(newBlob)
  } else {
    const data = window.URL.createObjectURL(newBlob)
  }

  var link = document.createElement('a')
  if (target) {
    link.target = target
  }
  link.href = data
  link.download = libelle + '.' + extension

  document.body.appendChild(link)
  link.click()
  // window.open(data)
  document.body.removeChild(link)
  // link.click()

  setTimeout(function () {
    window.URL.revokeObjectURL(data)
  }, 100)
}

export function getFileIcon() {
  const extensionIcon = []
  extensionIcon['pdf'] = 'icone_pdf.png'
  extensionIcon['doc'] = 'icone_word.png'
  extensionIcon['docx'] = 'icone_word.png'
  extensionIcon['png'] = 'icone_png.png'
  extensionIcon['jpg'] = 'icone_jpg.png'
  extensionIcon['jpeg'] = 'icone_jpg.png'
  extensionIcon['csv'] = 'icone_excel.png'
  extensionIcon['xls'] = 'icone_excel.png'
  extensionIcon['xlsx'] = 'icone_excel.png'
  extensionIcon['txt'] = 'icone_txt.png'
  extensionIcon['zip'] = 'icone_zip.png'
  extensionIcon['rar'] = 'icone_zip.png'
  extensionIcon['7z'] = 'icone_zip.png'
  extensionIcon['ppt'] = 'icone_ppt.png'
  extensionIcon['pptx'] = 'icone_ppt.png'
  extensionIcon['gif'] = 'icone_gif.png'
  extensionIcon['tif'] = 'icone_tif.png'
  extensionIcon['tiff'] = 'icone_tif.png'
  extensionIcon['xml'] = 'xml-file_24.png'
  extensionIcon['inconnu'] = 'icone_fichier_inconnu.png'
  return extensionIcon
}

export const getDangerousExtension = ['xlsx', 'pptx', 'docx']

export const permittedExtension = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'tif', 'tiff', 'png', 'gif', 'jpg', 'jpeg', 'ppt', 'pptx', 'txt', 'csv']

export const permittedImageExtension = ['tif', 'tiff', 'png', 'gif', 'jpg', 'jpeg']

export const getForbidenExtension = ['zip', 'rar', '7z', 'exe', 'bat', 'msi']

export const guardedFile = ['zip']

export function getIconSrc(pj) {
  // console.log('pj',pj)
  if (!isEmpty(pj)) {
    // let images = require.context('../assets/images/', false, /\.png$/)
    let images = require.context('../assets/images/', false, /^\.\/\S+.*\.[a-zA-Z]+$/)
    // console.log('images',images)
    let extensionIcon = getFileIcon()
    // console.log('pj.extension',pj.extension,pj)
    let icon = extensionIcon[pj.extension.trim().toLowerCase()] !== undefined
      ? extensionIcon[pj.extension.trim().toLowerCase()]
      : extensionIcon['inconnu']
    return images('./' + icon);
  }
  return '';
}

export function getReadableFileSize(fileSizeInBytes) {
  let i = -1;
  let byteUnits = [' ko', ' Mo', ' Go', ' To', 'Po', 'Eo', 'Zo', 'Yo'];
  do {
    fileSizeInBytes = fileSizeInBytes / 1024;
    i++;
  } while (fileSizeInBytes > 1024);
  return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
}

export function checkNIR(nir) {

  let NoSS = nir.substring(0, 13)
  let CleSaisie = nir.substring(13)

  let NoSaisi = NoSS

  if (NoSS.charAt(6).toUpperCase() == 'A') {
    NoSaisi = NoSS.replace(/A/i, '0')
    NoSaisi = NoSaisi - 1000000
    NoSaisi = NoSaisi.toString()
  }
  if (NoSS.charAt(6).toUpperCase() == 'B') {
    NoSaisi = NoSS.replace(/B/i, '0')
    NoSaisi = NoSaisi - 2000000
    NoSaisi = NoSaisi.toString()
  }

  let CleCalculee = 97 - (NoSaisi % 97)

  if (CleCalculee < 10) {
    CleCalculee = "0" + CleCalculee
  }
  //alert(CleCalculee)
  if (CleCalculee == CleSaisie) {
    return true
  } else {
    return false
  }
}

export function checkSIREN(siren) {

  siren = siren.replace(/ /gm, '');

  if (siren === "") {
    return false;
  } else {
    if (siren.length !== 9) {
      return false;
    } else {
      let somme = 0;
      let tmp;
      for (let cpt = 0; cpt < siren.length; cpt++) {
        if ((cpt % 2) === 1) {
          tmp = siren.charAt(cpt) * 2;
          if (tmp > 9) {
            tmp -= 9;
          }
        } else {
          tmp = siren.charAt(cpt);
        }
        somme += parseInt(tmp);
      }
      return (somme % 10) === 0;
    }
  }
}

export function checkSIRET(siret) {
  let estValide;
  if ( (siret.length != 14) || (isNaN(siret)) )
    estValide = false;
  else {
     // Donc le SIRET est un numérique à 14 chiffres
     // Les 9 premiers chiffres sont ceux du SIREN (ou RCS), les 4 suivants
     // correspondent au numéro d'établissement
     // et enfin le dernier chiffre est une clef de LUHN. 
    let somme = 0;
    let tmp;
    for (let cpt = 0; cpt<siret.length; cpt++) {
      if ((cpt % 2) == 0) { // Les positions impaires : 1er, 3è, 5è, etc... 
        tmp = siret.charAt(cpt) * 2; // On le multiplie par 2
        if (tmp > 9) 
          tmp -= 9; // Si le résultat est supérieur à 9, on lui soustrait 9
      }
      else
        tmp = siret.charAt(cpt);
      somme += parseInt(tmp);
    }
    if ((somme % 10) == 0)
      estValide = true; // Si la somme est un multiple de 10 alors le SIRET est valide 
    else
      estValide = false;
  }
  return estValide;
}

export function isEmpty(value) {
  // console.log('function isEmpty, value',typeof value,Array.isArray(value), value)
  if (Array.isArray(value)) {
    // console.log('function isEmpty, value', value, value.length)
    return value.length === 0
  } else if (value && typeof value === 'object' && value.constructor === Object) {
    return Object.keys(value).length === 0;
  } else {
    return (value === '' || value === ' ' || value === undefined || value === null);
  }
}

export function nl2br (str) {
  if (typeof str === 'undefined' || str === null) {
    return '';
  }
  var breakTag = '<br>';
  return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}

export function getTimestamp() {
  let date = new Date;
  let day = date.getDate().toString().length === 1 ? '0'+date.getDate().toString() : date.getDate().toString();
  let month = (date.getMonth()+1).toString().length === 1 ? '0'+(date.getMonth()+1).toString() : (date.getMonth()+1).toString();
  let year = date.getFullYear().toString();

  return day+'_'+month+'_'+year;
}
